// Hex values for Recharts / SVG props that can't consume CSS custom properties.
// All other brand usage should go through Tailwind tokens (bg-sitruna-yellow etc).
export const YELLOW = '#FFC600';
export const BLACK  = '#2D3647';
export const CREAM  = '#F9F7F2';
